// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__ybD5g","active":"Sidebar_active__lVZ_U"};